import {POST, PATCH} from "@/services/gateway";

const listIncludeInBackups = ({providerType, seatType}) => {
  return POST('backup-config/global/fetch-config', {providerType, seatType});
}

const updateIncludeInBackup = ({seatType, providerType, applyToAll, config}) => {
  return PATCH('backup-config/global/update', {seatType, providerType, applyToAll, config});
}

const updateLocalIncludeInBackup = ({id, seatType, providerType, config}) => {
  return PATCH('backup-config/local/update', {id, seatType, providerType, config});
}

export {
  listIncludeInBackups,
  updateIncludeInBackup,
  updateLocalIncludeInBackup
}
